<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="标题">
                <a-input v-model="queryParam.title" placeholder="请输入标题" allow-clear @press-enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-tabs type="card" :activeKey="handleTabKey" @change="onHandleTabChange" style="margin-bottom: 16px">
        <a-tab-pane key="0" tab="待处理" />
        <a-tab-pane key="1" tab="已处理" />
        <a-tab-pane key="2" tab="他人已处理" />
      </a-tabs>
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['diandian:announcement:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="priority" slot-scope="text">
          {{ priorityText(text) }}
        </span>
        <span slot="readStatus" slot-scope="text">
          {{ readStatusText(text) }}
        </span>
        <span slot="handleStatus" slot-scope="text">
          {{ handleStatusText(text) }}
        </span>
        <span slot="bizType" slot-scope="text, record">
          {{ record.bizTypeName || record.bizType || '—' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['diandian:announcement:list']">
            <a-icon type="file-text" />详情
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['diandian:announcement:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <a-modal
        :visible="detailVisible"
        :title="(detailRecord && detailRecord.title) || '公告详情'"
        width="720px"
        @cancel="handleCloseDetail"
      >
        <a-spin :spinning="detailLoading">
          <div v-if="detailRecord" class="announcement-detail">
            <p><strong>业务类型：</strong>{{ detailRecord.bizTypeName || detailRecord.bizType || '—' }}</p>
            <p><strong>优先级：</strong>{{ priorityText(detailRecord.priority) }}</p>
            <p><strong>读取状态：</strong>{{ readStatusText(detailRecord.readStatus) }}</p>
            <p><strong>处理状态：</strong>{{ handleStatusText(detailRecord.handleStatus) }}</p>
            <p v-if="detailRecord.handleTime"><strong>处理时间：</strong>{{ parseTime(detailRecord.handleTime) }}</p>
            <p v-if="detailRecord.handleUserName || detailRecord.handleUserId">
              <strong>处理人：</strong>{{ detailRecord.handleUserName || detailRecord.handleUserId }}
            </p>
            <p><strong>内容：</strong></p>
            <div class="announcement-detail__content">{{ detailRecord.content || '—' }}</div>
          </div>
        </a-spin>
        <template slot="footer">
          <a-button @click="handleCloseDetail">关闭</a-button>
          <a-button
            v-if="detailRecord && canGoProcess"
            type="primary"
            :disabled="detailLoading"
            @click="handleGoProcess"
          >
            去处理
          </a-button>
        </template>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAnnouncement, delAnnouncement, getAnnouncement, markReadAnnouncement } from '@/api/diandian/announcement'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'BizAnnouncement',
  components: { CreateForm },
  mixins: [tableMixin],
  watch: {
    routeAnnouncementOpenKey: {
      handler () {
        this.handleRouteOpen()
      },
      immediate: true
    }
  },
  computed: {
    isPendingTab () {
      return this.handleTabKey === '0'
    },
    canGoProcess () {
      const r = this.detailRecord
      return this.isPendingTab && !!(r && r.routePath && String(r.routePath).trim())
    },
    routeAnnouncementOpenKey () {
      const q = (this.$route && this.$route.query) || {}
      if (!q.announcementId) {
        return ''
      }
      const hs = q.handleStatus != null ? String(q.handleStatus) : '0'
      return `${String(q.announcementId)}:${hs}`
    }
  },
  data () {
    return {
      handleTabKey: '0',
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      detailVisible: false,
      detailLoading: false,
      detailRecord: null,
      _announcementDetailRequestingId: null,
      queryParam: {
        title: null,
        bizType: null,
        handleStatus: 0,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '序号', dataIndex: 'index', width: 70, align: 'center', customRender: (text, record, index) => index + 1 },
        { title: '标题', dataIndex: 'title', ellipsis: true, align: 'center' },
        { title: '业务类型', key: 'bizType', width: 140, ellipsis: true, align: 'center', scopedSlots: { customRender: 'bizType' } },
        { title: '优先级', dataIndex: 'priority', width: 90, align: 'center', scopedSlots: { customRender: 'priority' } },
        { title: '读取状态', dataIndex: 'readStatus', width: 100, align: 'center', scopedSlots: { customRender: 'readStatus' } },
        { title: '处理状态', dataIndex: 'handleStatus', width: 110, align: 'center', scopedSlots: { customRender: 'handleStatus' } },
        { title: '接收人', dataIndex: 'receiveUserId', width: 120, ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 170, align: 'center', scopedSlots: { customRender: 'createTime' } },
        { title: '操作', dataIndex: 'operation', width: 200, align: 'center', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created () {
    const q = (this.$route && this.$route.query) || {}
    if (!q.announcementId) {
      this.getList()
    }
  },
  methods: {
    priorityText (p) {
      if (p === 1) return '重要'
      if (p === 2) return '紧急'
      return '普通'
    },
    readStatusText (status) {
      return status === 1 ? '已读' : '未读'
    },
    handleStatusText (status) {
      if (status === 1) return '已处理'
      if (status === 2) return '他人已处理'
      return '待处理'
    },
    onHandleTabChange (key) {
      this.handleTabKey = key
      this.queryParam.handleStatus = parseInt(key, 10)
      this.queryParam.pageNum = 1
      this.onSelectChange([], [])
      this.getList()
    },
    parseRouteQuery (raw) {
      if (raw == null || raw === '') return {}
      try {
        const o = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (o && typeof o === 'object' && !Array.isArray(o)) {
          const q = {}
          Object.keys(o).forEach(k => {
            const v = o[k]
            q[k] = v == null ? '' : String(v)
          })
          return q
        }
      } catch (e) {
        /* ignore */
      }
      return {}
    },
    handleDetail (record) {
      if (!record || !record.id) return
      const id = record.id
      if (this._announcementDetailRequestingId === id) {
        return
      }
      this._announcementDetailRequestingId = id
      this.detailVisible = true
      this.detailLoading = true
      this.detailRecord = null
      getAnnouncement({ id })
        .then(response => {
          this.detailRecord = response.data
          return markReadAnnouncement({ id })
        })
        .then(() => {
          this.getList()
        })
        .catch(() => {
          if (!this.detailRecord) {
            this.detailVisible = false
          }
        })
        .finally(() => {
          this.detailLoading = false
          if (this._announcementDetailRequestingId === id) {
            this._announcementDetailRequestingId = null
          }
        })
    },
    handleRouteOpen () {
      const query = (this.$route && this.$route.query) || {}
      const announcementId = query.announcementId
      if (!announcementId) {
        return
      }
      const handleStatus = query.handleStatus != null ? String(query.handleStatus) : '0'
      if (this.handleTabKey !== handleStatus) {
        this.handleTabKey = handleStatus
        this.queryParam.handleStatus = parseInt(handleStatus, 10)
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        this.handleDetail({ id: announcementId })
      })
    },
    handleCloseDetail () {
      this.detailVisible = false
      this.detailRecord = null
      this.clearRouteAnnouncementQuery()
    },
    handleGoProcess () {
      const record = this.detailRecord
      if (!record || !record.routePath || !String(record.routePath).trim()) {
        this.$message.warning('未配置跳转路由，无法去处理')
        return
      }
      const path = record.routePath.startsWith('/') ? record.routePath : '/' + record.routePath
      const query = this.parseRouteQuery(record.routeQuery)
      if (record.bizId != null && record.bizId !== '') {
        query.id = String(record.bizId)
      }
      this.handleCloseDetail()
      this.$router.push({ path, query })
    },
    clearRouteAnnouncementQuery () {
      const query = { ...(this.$route.query || {}) }
      if (!query.announcementId && query.handleStatus == null) {
        return
      }
      delete query.announcementId
      delete query.handleStatus
      this.$router.replace({ path: this.$route.path, query }).catch(() => {})
    },
    getList () {
      this.loading = true
      pageAnnouncement(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam.title = null
      this.queryParam.bizType = null
      this.queryParam.handleStatus = parseInt(this.handleTabKey, 10)
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = this.queryParam.pageSize
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      const that = this
      const ids = row && row.id ? [row.id] : this.ids
      if (!ids.length) {
        return
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为 ' + ids.join(',') + ' 的数据',
        onOk () {
          const data = ids.map(id => ({ id: id }))
          return delAnnouncement(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.announcement-detail__content {
  white-space: pre-wrap;
  word-break: break-word;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 4px;
  min-height: 80px;
}
</style>
